export default __webpack_public_path__ + "static/media/INFOCOIN-LIMITED.0b11ec9a.svg";